//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ValidationObserver } from 'vee-validate'
import TagStep from '@/components/Shared/TagStep.vue'
import Button from '~/components/Shared/Button'
import ContactField from '~/components/Form/ContactField.vue'
export default {
  components: {
    ValidationObserver,
    Button,
    ContactField,
    TagStep,
  },
  data() {
    return {
      form: {
        contact: '',
        type: 'email',
      },
    }
  },
  async mounted() {
    const { email, phone } = this.$strapi.user
    if (!!email || !!phone) {
      await this.$router.push('/inicio')
    }
  },
  methods: {
    async submitForm() {
      this.$store.commit('loading', true)
      try {
        const isAvailable = await this.isContactAvailable()
        if (!isAvailable) {
          await this.$store.dispatch(
            'core/errorMessage',
            'El contacto ya se encuentra registrado'
          )
          return
        }
        const submitForm = {
          id: this.$strapi.user.id,
          [this.form.type]: this.form.contact,
        }
        await this.saveProfile(submitForm)
        await this.$router.push('/inicio')
      } catch (error) {
        await this.$store.dispatch(
          'core/errorMessage',
          this.$t('misc.errors.genericError')
        )
      } finally {
        this.$store.commit('loading', false)
      }
    },
    async isContactAvailable() {
      const existuserWithContact = await this.$repository.user.getByContact({
        type: this.form.type,
        contact: this.form.contact,
        user_origin: 'relink',
      })
      return !existuserWithContact?.exists
    },
    async saveProfile(user) {
      await this.$repository.me.update(user)
      await this.$store.dispatch('me/fetchUser')
    },
    handleExit() {
      this.$router.push('/salir')
    },
  },
}
